import { render } from "./TextInput.vue?vue&type=template&id=19d83020"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"
script.render = render

export default script